import $ from 'jquery'
import algoliasearch from 'algoliasearch/lite'
import { algoliaApiKey, algoliaAppId, placeSearchIndex } from '../variables'

const searchClient = algoliasearch(algoliaAppId, algoliaApiKey)
const searchIndex = searchClient.initIndex(placeSearchIndex)
// eslint-disable-next-line no-undef
const object = vnObject

// eslint-disable-next-line no-undef
const { __, sprintf } = wp.i18n

if ($('body').hasClass('single-location')) {
  const location_post = $('.s-location')
  let lat_lng = location_post.data('lat_lng')
  let algolia_polygon = location_post.data('algolia_polygon')
  let requestOptions = {
  }
  if (algolia_polygon && algolia_polygon.length > 0) {
    requestOptions.insidePolygon = algolia_polygon
  } else {
    requestOptions.aroundLatLng = lat_lng
    requestOptions.aroundRadius = eval(object.defaultRadius * 1000)
  }
  //console.log('CAMILLE')
  //console.log(requestOptions)
  searchIndex
    .search('', requestOptions)
    .then(({ hits }) => {
      if (hits.length > 0) {
        if (hits.length === 1) {
          $('.s-location__number-places').html(
            `<p> ${sprintf(
              __('%d result await you there', 'vn'),
              hits.length
            )}</p>`
          )
        } else {
          $('.s-location__number-places').html(
            `<p> ${sprintf(
              __('%d results await you there', 'vn'),
              hits.length
            )}</p>`
          )
        }
      }
    })
    .catch((err) => {
      console.error(err)
    })
}
